import { Tooltip, TooltipTrigger, TooltipContent } from '@/components/ui/tooltip';

/**
 * A button wrapped with a styled Radix tooltip.
 * Drop-in replacement for <button title="..."> pattern.
 *
 * Usage:
 *   <TipBtn tip="Edit" onClick={...} className="...">
 *     <IconEdit size={18} />
 *   </TipBtn>
 */
export default function TipBtn({ tip, side = 'top', children, className = '', disabled, ...rest }) {
    const btn = (
        <button className={className} disabled={disabled} {...rest}>
            {children}
        </button>
    );

    if (!tip) return btn;

    return (
        <Tooltip>
            <TooltipTrigger asChild>
                {btn}
            </TooltipTrigger>
            <TooltipContent side={side}>
                {tip}
            </TooltipContent>
        </Tooltip>
    );
}
